__turbopack_context__.v({
  "container": "PageLoader-module__lLlWCG__container",
  "content": "PageLoader-module__lLlWCG__content",
  "dot": "PageLoader-module__lLlWCG__dot",
  "dots": "PageLoader-module__lLlWCG__dots",
  "fx": "PageLoader-module__lLlWCG__fx",
  "positionAbsolute": "PageLoader-module__lLlWCG__positionAbsolute",
});
